import { render } from "./Indirim.vue?vue&type=template&id=0e870efa"
import script from "./Indirim.vue?vue&type=script&lang=js"
export * from "./Indirim.vue?vue&type=script&lang=js"

import "./Indirim.vue?vue&type=style&index=0&id=0e870efa&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__